import React from 'react';
import { LanguageSwitcher } from './LanguageSwitcher';

interface AuthLayoutProps {
  children: React.ReactNode;
  backgroundImage?: string;
}

export function AuthLayout({
  children,
  backgroundImage = '/assets/images/auth/auth-cover-login-bg.svg'
}: AuthLayoutProps) {
  return (
    <main className="auth-cover-wrapper">
      <div className="auth-cover-content-inner">
        <div className="auth-cover-content-wrapper">
          <div className="auth-img">
            <img src={backgroundImage} alt="" className="img-fluid" />
          </div>
        </div>
      </div>
      <div className="auth-cover-sidebar-inner">
        <div className="position-absolute top-0 end-0 p-4">
          <LanguageSwitcher />
        </div>
        <div className="auth-cover-card-wrapper">
          <div className="auth-cover-card p-sm-5">
            {children}
          </div>
        </div>
      </div>
    </main>
  );
}
